/* eanae-common.js — 모든 화면 공통 런타임.
   책임: (1) PT/EN 언어 토글 — Liquid 마크업은 .i18n/data-en innerHTML swap,
            JS 렌더 화면(Shop·PDP)은 eanae-lang-change 이벤트로 re-render.
            PT가 마크업의 정본, EN은 data-en 스왑. 한글(KO)은 fb2에서 전면 삭제.
        (2) 사이드 드로어 열고/닫기 + 헤더 검색 아이콘 → 드로어 열고 입력 포커스.
        (3) 드로어 내 검색 — 빈 입력이면 추천 칩, 입력 중이면 실시간 결과 최대 5건.
   책임 아님: 화면별 렌더(eanae-home/shop/product.js). 장바구니·결제 없음(구매는 오상 외부 링크). */
(function () {
  "use strict";
  var LANG_KEY = "eanae-lang";
  var MAX_RESULTS = 5;

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  /* ---------- 언어 ---------- */
  function getLang() {
    try {
      var l = localStorage.getItem(LANG_KEY);
      // fb2 이전 방문자의 localStorage 에 "ko" 가 남아 있어도 PT 로 떨어뜨린다.
      return l === "en" ? "en" : "pt";
    } catch (e) {
      return "pt";
    }
  }
  function translatedValue(el, lang, suffix) {
    var translated = el.getAttribute("data-" + lang + suffix);
    return translated !== null ? translated : el.getAttribute("data-pt" + suffix);
  }
  function applyTranslatedAttr(selector, attr, suffix, lang) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute("data-pt" + suffix) === null)
        el.setAttribute("data-pt" + suffix, el.getAttribute(attr) || "");
      el.setAttribute(attr, translatedValue(el, lang, suffix) || "");
    }
  }
  function applyLang(lang) {
    var nodes = document.querySelectorAll(".i18n");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute("data-pt") === null)
        el.setAttribute("data-pt", el.innerHTML);
      el.innerHTML = translatedValue(el, lang, "") || "";
    }
    applyTranslatedAttr("[data-en-ph]", "placeholder", "-ph", lang);
    applyTranslatedAttr("[data-en-label]", "aria-label", "-label", lang);
    applyTranslatedAttr("[data-en-title]", "title", "-title", lang);
    applyTranslatedAttr("[data-en-content]", "content", "-content", lang);
    document.documentElement.lang = lang === "en" ? "en" : "pt-BR";
    document.documentElement.setAttribute("data-lang", lang);
    try {
      localStorage.setItem(LANG_KEY, lang);
    } catch (e) {}
    var btns = document.querySelectorAll("[data-lang-btn]");
    for (var j = 0; j < btns.length; j++) {
      btns[j].setAttribute(
        "aria-pressed",
        btns[j].getAttribute("data-lang-btn") === lang ? "true" : "false",
      );
    }
    try {
      window.dispatchEvent(new CustomEvent("eanae-lang-change", { detail: lang }));
    } catch (e) {}
  }
  window.EANAE_LANG = { get: getLang, set: applyLang };

  /* ---------- 드로어 + 검색 ---------- */
  function bindDrawer() {
    var drawer = document.querySelector("[data-drawer]");
    var scrim = document.querySelector("[data-drawer-scrim]");
    var input = document.querySelector("[data-search-input]");
    var chips = document.querySelector("[data-search-chips]");
    var out = document.querySelector("[data-search-results]");

    function open(o) {
      if (drawer)
        o ? drawer.setAttribute("data-open", "") : drawer.removeAttribute("data-open");
      if (scrim)
        o ? scrim.setAttribute("data-open", "") : scrim.removeAttribute("data-open");
      document.documentElement.style.overflow = o ? "hidden" : "";
    }

    function renderSearch() {
      if (!input || !out) return;
      var q = (input.value || "").trim().toLowerCase();
      if (chips) chips.hidden = q.length > 0;
      if (!q) {
        out.innerHTML = "";
        return;
      }
      var D = window.EANAE_DATA;
      if (!D) return;
      var lang = getLang();
      function t(v) {
        return v && typeof v === "object" ? (v[lang] != null ? v[lang] : v.pt) : v || "";
      }
      var hits = (D.PRODUCTS || [])
        .filter(function (p) {
          var hay = (p.name + " " + (p.kw || "") + " " + t(p.sub) + " " + t(p.cat)).toLowerCase();
          return hay.indexOf(q) !== -1;
        })
        .slice(0, MAX_RESULTS);
      if (!hits.length) {
        out.innerHTML = '<p class="ea-drawer__none">—</p>';
        return;
      }
      out.innerHTML = hits
        .map(function (p) {
          return (
            '<a class="ea-drawer__hit" href="/?view=produto&id=' + esc(p.id) + '">' +
            '<span class="ea-drawer__hitimg"><img src="' + esc(eanaeAsset(p.img)) + '" alt="" loading="lazy"></span>' +
            '<span class="ea-drawer__hitname">' + esc(p.name) + "</span>" +
            "</a>"
          );
        })
        .join("");
    }

    document.addEventListener("click", function (ev) {
      var t = ev.target;
      if (!t.closest) return;
      if (t.closest("[data-search-open]")) {
        open(true);
        setTimeout(function () {
          if (input) input.focus();
        }, 60);
      } else if (t.closest("[data-drawer-open]")) open(true);
      else if (t.closest("[data-drawer-close]")) open(false);
      else if (t.closest("[data-drawer] a")) open(false);
    });
    if (scrim) scrim.addEventListener("click", function () { open(false); });
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") open(false);
    });
    if (input) input.addEventListener("input", renderSearch);
    window.addEventListener("eanae-lang-change", renderSearch);
  }

  function init() {
    applyLang(getLang());
    document.addEventListener("click", function (ev) {
      var b = ev.target.closest && ev.target.closest("[data-lang-btn]");
      if (b) applyLang(b.getAttribute("data-lang-btn"));
    });
    bindDrawer();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
